var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('md-progress-bar',{attrs:{"md-mode":"query"}}):_c('md-autocomplete',{attrs:{"md-options":_vm.options,"md-fuzzy-search":false},on:{"md-selected":_vm.updateFilter},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},[_c('label',[_vm._v("Server Bundles")])])
}
var staticRenderFns = []

export { render, staticRenderFns }